/***************************************************************************/
"use client";
/***************************************************************************/

const ScreenHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

export { ScreenHeader };
